import HttpStatus from 'redpoints-connector-common/enumeration/HttpStatus';

import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  ALL_INCIDENTS_CLEAR,
  ALL_INCIDENTS_TABLE_EXPORT_BRAND_PERMISSION,
} from '../../../../actions/actionTypes';

const tableExportBrandPermission = fetchReducerGenerator(
  ALL_INCIDENTS_CLEAR,
  ALL_INCIDENTS_TABLE_EXPORT_BRAND_PERMISSION
);

export default tableExportBrandPermission;

export const getAllIncidentsTableHasExportBrandPermission = state =>
  state.response
    ? state.response.status === HttpStatus.NO_CONTENT.value
    : false;
